import { IJob, IJobRevenue, ILocation } from 'wisestep-api';

import { INFO_TYPE, InfoDetail } from '../components/infoDetailsCard/InfoDetailsCard';

export const formatInternational = (num: number) => num.toLocaleString('en-US');

export const formatIndian = (num: number) => num.toLocaleString('en-IN');

const getLocationString = (locations: ILocation[] = []): string =>
  locations
    .map((loc) => {
      return [loc?.city, loc?.state, loc?.country].filter(Boolean).join(', ');
    })
    .join(' | ');

const getSalaryString = (
  minSalary: number,
  maxSalary: number,
  timeSpan: string,
  salaryCurrency: string
) =>
  `${salaryCurrency} ${formatInternational(minSalary)} - ${formatInternational(
    maxSalary
  )} ${timeSpan}`;

const getNumberedCurrency = (salaryCurrency: string, number: number): string =>
  `${salaryCurrency} ${formatInternational(number)}`;

export const getJobBasicDetails = (job: IJob): InfoDetail[] => [
  {
    label: 'Location',
    value: job?.locations?.length ? getLocationString(job?.locations) : '-',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'Salary',
    value:
      job?.salaryCurrency && job?.minimumSalary && job?.maximumSalary && job?.salaryTimeSpan
        ? getSalaryString(
            job?.minimumSalary,
            job?.maximumSalary,
            job?.salaryTimeSpan,
            job?.salaryCurrency
          )
        : '-',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'No. of Recruiters accepted job',
    value: job?.assignedTo
      ? `${job.assignedTo.filter((assignedTo) => assignedTo.isAccepted == true).length} of ${
          job.assignedTo?.length
        } recruiters accepted`
      : '-',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'Workspace preference',
    value: job?.workplacePreference ?? '-',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'No. of Job Boards Published on',
    value: job?.jobBoardPosting?.length.toString() ?? '-',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'No. of Positions',
    value: job?.numberOfPositions?.toString() ?? '-',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'Remote Availability',
    value: job?.remoteJob ? 'Yes' : 'NO',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'Education Requirements',
    value: job?.educationRequirements?.join(', ') ?? '-',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'Required Experience',
    value: job?.experienceRequirements?.join(', ') ?? '-',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'Job Type',
    value: job?.jobType ?? '-',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'Job Status Type',
    value: job?.jobStatusType ?? '-',
    type: INFO_TYPE.TEXT,
  },
];

export const getRevenueInformation = (jobRevenue: IJobRevenue, job: IJob): InfoDetail[] => [
  {
    label: 'Fee Arrangement',
    value: jobRevenue?.feeArrangement?.feeArrangementLevel ?? '-',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'Arrangement Type',
    value: jobRevenue?.feeArrangement?.contractType ?? '-',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'Maximum Salary',
    value:
      job?.salaryCurrency && job?.maximumSalary
        ? getNumberedCurrency(job?.salaryCurrency, job?.maximumSalary)
        : '-',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'Potential Revenue',
    value:
      jobRevenue?.potentialRevenue && job?.salaryCurrency
        ? getNumberedCurrency(job?.salaryCurrency, jobRevenue?.potentialRevenue)
        : '-',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'Gross Revenue',
    value:
      jobRevenue?.grossRevenue && job?.salaryCurrency
        ? getNumberedCurrency(job?.salaryCurrency, jobRevenue?.grossRevenue)
        : '-',
    type: INFO_TYPE.TEXT,
  },
  {
    label: 'Net Revenue',
    value:
      jobRevenue?.netFeeIncome && job?.salaryCurrency
        ? getNumberedCurrency(job?.salaryCurrency, jobRevenue?.netFeeIncome)
        : '-',
    type: INFO_TYPE.TEXT,
  },
];
